import { DocumentTypeCat } from '@ps/platform-message-framework/common/DocumentTypeCat';
import React, { useMemo } from 'react';
import { useField } from 'react-final-form';
import { useSelector } from 'react-redux';

import { Country as CountryEnum } from '@swf/core/enums';
import { select } from '@swf/core/store';

import { TaxCodeType } from '../../../../../../../../validators/taxCode';
import StateField from '../../../../../RMFAddress/components/Fields/components/StateField';
import DocumentDescriptionField from '../../../../../RMFDocumentation/components/DocumentDescriptionField/DocumentDescriptionField';
import DocumentTypeField from '../../../../../RMFDocumentation/components/DocumentTypeField/DocumentTypeField';
import SecondFamilyName from '../../../../../RMFLegalName/components/SecondFamilyName/SecondFamilyName';
import TaxCodeField from '../../components/TaxCodeField/TaxCodeField';

const ESFields: React.FC = () => {
  const signupCountry = useSelector(select.account.getCountry);

  const {
    input: { value: country }
  } = useField('country', { initialValue: signupCountry });

  const {
    input: { value: docType }
  } = useField('docType', { subscription: { value: true } });

  const {
    input: { value: citizenship }
  } = useField('citizenship', { subscription: { value: true }, initialValue: signupCountry });

  const isCountrySpain = country === CountryEnum.Spain;
  const isSpanishCitizen = citizenship === CountryEnum.Spain;

  const taxCodeType: TaxCodeType | null = useMemo(() => {
    switch (true) {
      case isCountrySpain && isSpanishCitizen:
        return TaxCodeType.DNI;
      case isCountrySpain && !isSpanishCitizen:
        return TaxCodeType.NIE;
      case !isCountrySpain && isSpanishCitizen:
        return TaxCodeType.DNI;
      default:
        return TaxCodeType.NONE;
    }
  }, [isCountrySpain, isSpanishCitizen]);

  return (
    <>
      {isSpanishCitizen && <SecondFamilyName />}
      {isCountrySpain && <StateField country={country} fieldName="state" />}
      <DocumentTypeField country={country} citizenship={citizenship} />
      {taxCodeType && <TaxCodeField taxCodeType={taxCodeType} />}
      {!isCountrySpain && !isSpanishCitizen && docType === DocumentTypeCat.OTHER && (
        <DocumentDescriptionField />
      )}
    </>
  );
};

export default ESFields;
